window.Site = window.Site || {
  ShowLoading() {
    const form = $('form')[0];
    if (!form || form.checkValidity()) {
      $('#global-loader').fadeIn('slow');
    }
  },

  HideLoading() {
    $('#global-loader').fadeOut('slow');
  },
};

$(function () {
  const $loader = $('#global-loader');
  if ($loader.length) {
    $loader.fadeOut('slow');
  }

  const $toast = $('.toast');
  if ($toast.length) {
    $toast.toast();
  }

  const $backToTop = $('#back-to-top');
  if ($backToTop.length) {
    const toggleBackToTop = () => {
      if ($(window).scrollTop() > 300) {
        $backToTop.fadeIn();
      } else {
        $backToTop.fadeOut();
      }
    };

    $(window).on('scroll.backToTop', toggleBackToTop);
    toggleBackToTop();

    $backToTop.on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 300);
    });
  }
});
